import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { MdClose } from 'react-icons/md';
import { Menu, Sun, Moon } from 'react-feather';
import { motion } from 'framer-motion';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('theme') === 'dark';
    }
    return false;
  });

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  const LinkItems = [
    { title: 'Home', link: '/' },
    { title: 'About', link: '/about-us' },
    // { title: 'Our Team', link: '/team' },
    { title: 'Contact', link: '/contact-us' },
  ];

  // const ProductLinks = [
  //   { title: 'FarmOS', link: '/products/farmos' },
  //   { title: 'Ashita Console', link: '/products/console' },
  //   { title: 'Farm Security', link: '/products/security' },
  //   { title: 'Farm AI', link: '/products/farm-ai' },
  // ];

  const LinkItem = ({ title, link }) => {
    const isActive = location.pathname === link;
    return (
      <Link
        to={link}
        className={`relative my-1 text-lg md:mx-3 md:my-0 transition-all duration-300 
          ${
            isActive
              ? 'text-[#F3C72C] font-bold'
              : 'text-gray-800 dark:text-gray-200 hover:text-[#F3C72C]'
          }`}
      >
        {title}
      </Link>
    );
  };

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 70, damping: 12 }}
      className="sticky top-0 z-50 w-full backdrop-blur-md bg-white/80 dark:bg-black/60 shadow-sm transition-all duration-300"
    >
      <div className="flex flex-col md:flex-row justify-between items-center px-5 md:px-20 py-3">
        {/* === Left Side: Logo and Tagline === */}
        <div className="flex justify-between items-center w-full md:w-auto">
          <div className="flex flex-col">
            <Logo />
            <span className="text-xs md:text-sm text-gray-500 dark:text-gray-400 italic -mt-1">
              Building technology tools that power africa.
            </span>
          </div>

          {/* === Mobile Controls === */}
          <div className="flex items-center space-x-3 md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-800 dark:text-gray-200 hover:text-yellow-400 focus:outline-none"
              aria-label="Toggle menu"
            >
              {isOpen ? <MdClose className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>

            <button
              onClick={() => setDarkMode(!darkMode)}
              className="text-gray-800 dark:text-gray-200 hover:text-yellow-400 focus:outline-none"
              aria-label="Toggle dark mode"
            >
              {darkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </button>
          </div>
        </div>

        {/* === Navigation Links === */}
        <div
          className={`md:flex items-center gap-6  rounded-2xl p-4 md:p-0 transition-all duration-300 ${
            isOpen ? 'mt-4' : 'hidden md:flex'
          }`}
        >
          {/* Main Links */}
          <div className="flex flex-col md:flex-row md:items-center md:space-x-6 text-center md:text-left">
            {LinkItems.map((item, i) => (
              <LinkItem key={i} title={item.title} link={item.link} />
            ))}

            {/* Console CTA */}
            <Link
              to="/cms-services"
              className="px-5 py-2 rounded-lg bg-black border border-[#F3C72C] text-white  transition-all"
            >
              CMS Services
            </Link>

            {/* Dark Mode Toggle */}
            <button
              onClick={() => setDarkMode(!darkMode)}
              className="hidden md:inline-flex text-gray-800 dark:text-gray-200 hover:text-yellow-400 focus:outline-none ml-3"
              aria-label="Toggle dark mode"
            >
              {darkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </button>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};
